import React, { useState } from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { WorkflowProvider } from './contexts/WorkflowContext';
import AuthWrapper from './components/AuthWrapper';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Canvas from './components/Canvas';
import WorkflowModal from './components/WorkflowModal';
import NodeSettingsModal from './components/NodeSettingsModal';
import OutputModal from './components/OutputModal';
import LoadingOverlay from './components/LoadingOverlay';
import './App.css';

function App() {
  const [showWorkflowModal, setShowWorkflowModal] = useState(false);
  const [showNodeSettings, setShowNodeSettings] = useState({ show: false, nodeData: null });
  const [showOutput, setShowOutput] = useState({ show: false, outputData: null });
  const [showLoading, setShowLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [loadingType, setLoadingType] = useState('loading');

  const handleShowWorkflowModal = () => {
    setShowWorkflowModal(true);
  };

  const handleHideWorkflowModal = () => {
    setShowWorkflowModal(false);
  };

  const handleShowNodeSettings = (nodeData) => {
    setShowNodeSettings({ show: true, nodeData });
  };

  const handleHideNodeSettings = () => {
    setShowNodeSettings({ show: false, nodeData: null });
  };

  const handleShowOutput = (outputData) => {
    setShowOutput({ show: true, outputData });
  };

  const handleHideOutput = () => {
    setShowOutput({ show: false, outputData: null });
  };

  const handleShowLoading = (message, type = 'loading') => {
    setLoadingMessage(message);
    setLoadingType(type);
    setShowLoading(true);
  };

  const handleHideLoading = () => {
    setShowLoading(false);
    setLoadingMessage('');
    setLoadingType('loading');
  };

  return (
    <AuthProvider>
      <WorkflowProvider>
        <AuthWrapper>
          <div className="App">
            <Header onNewWorkflow={handleShowWorkflowModal} />
            <div className="main-content">
              <Sidebar />
              <Canvas
                onShowNodeSettings={handleShowNodeSettings}
                onShowOutput={handleShowOutput}
                onShowLoading={handleShowLoading}
                onHideLoading={handleHideLoading}
              />
            </div>

            {/* Modals */}
            {showWorkflowModal && (
              <WorkflowModal onClose={handleHideWorkflowModal} />
            )}

            {showNodeSettings.show && (
              <NodeSettingsModal
                node={showNodeSettings.nodeData}
                onClose={handleHideNodeSettings}
              />
            )}

            {showOutput.show && (
              <OutputModal
                output={showOutput.outputData}
                onClose={handleHideOutput}
              />
            )}

            {/* Loading Overlay */}
            <LoadingOverlay
              show={showLoading}
              message={loadingMessage}
              type={loadingType}
            />
          </div>
        </AuthWrapper>
      </WorkflowProvider>
    </AuthProvider>
  );
}

export default App;
